/**
 * This class represents the WTP report controller ReportData API parameter structure and is used as a DTO to be serialized and sent to the backend.
 */
export class ReportData {
	private reportData: any = {};
	private setParams: any = {};
	public deserializeAndSetParams: any; // toolContext ??
	public tracking: Map<string, any> = new Map<string, any>();
	public save: boolean = true;
	public fileName: string;
	public svgPages: string[];
	public compressPdf: boolean = true;

	constructor(private template?: string, private birtOutputFormat?: string) { }

	public addParam(param: string, value: any): ReportData {
		this.setParams[param] = value;
		return this;
	}

	public addReportData(param: string, value: any): ReportData {
		this.reportData[param] = value;
		return this;
	}

	public addTracking(key: string, value: any): ReportData {
		this.tracking.set(key, value);
		return this;
	}
}
